import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import env from '@/env';
import { SqoFile } from '@/common';

export const getArchiveDocuments = async (id: string, docType: string): Promise<SqoFile[]> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-visits/${id}/documents/${docType}`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as SqoFile[];
  return response;
};
